import { Injectable } from '@angular/core';
import { fallbackString } from 'src/app/helpers/type-helpers';
import { IAdapter } from 'src/app/models';
import { Partner } from 'src/app/models/domain';
import { YPMPARTNERVCDSYpmPartnerVType } from 'src/generated-clients/partner';

@Injectable({
  providedIn: 'root',
})
export class PartnerAdapter implements IAdapter<Partner, YPMPARTNERVCDSYpmPartnerVType> {
  public adaptToDomain(item: YPMPARTNERVCDSYpmPartnerVType): Partner {
    return new Partner(
      fallbackString(item.ObjectNumber),
      fallbackString(item.ChangedTime),
      fallbackString(item.ChangedBy),
      fallbackString(item.PartnerFunction),
      fallbackString(item.Counter),
      fallbackString(item.Partner),
      fallbackString(item.VendorName),
      fallbackString(item.CreatedDate),
      fallbackString(item.CreatedTime),
      fallbackString(item.CreatedBy),
      fallbackString(item.ChngedDate)
    );
  }
}
